import _startCase from 'lodash/startCase';

export default function(VueInstance) {
  VueInstance.filter('startCase', (value) => _startCase(value));
};
